<template>
  <div class="downloads">
    <div class="head">
      <img :src="logoUrl" alt="图片加载失败" lazy />
      <span class="head_Return" @click="$router.go(-1)">返回主页</span>
    </div>
    <div class="cont">
      <el-row style="display: flex; justify-content: center; align-items: center">
        <el-col :lg="16" :md="24">
          <el-row :gutter="20">
            <el-col style="margin-bottom: 12px" v-for="(item, index) in versionArr.version" :key="index" :lg="12" :md="24">
              <el-card class="box-card">
                <div slot="header">
                  <span style="color: #5879ff; font-size: 20px">{{ typeArr.find((items) => items.type == item.type).name }}</span>
                  <el-button @click="openDow(item)" style="float: right; padding: 3px 0" type="text"><i class="dow_icon"></i> 点击下载</el-button>
                </div>
                <div class="text item">
                  <div style="color: #777">
                    <img :src="typeArr.find((items) => items.type == item.type).url" align="left" style="margin-right: 20px" />
                    {{ typeArr.find((items) => items.type == item.type).dis }}
                    <br />
                    <br />
                    <p style="font-size: 10px">最新版本： {{ item.versionCode }}</p>
                    <p style="font-size: 10px">更新时间： {{ item.updated_at }}</p>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-dialog :show-close="false" title="扫码下载" @opened="openDialog" :visible="dialogVisible" width="500px">
      <div class="dialog" style="padding: 0 0 10%">
        <div id="qrCode" ref="qrCodeUrl"></div>
        <p class="describe">扫描二维码下载客户端</p>
      </div>
      <div style="text-align: center">
        <el-button type="primary" @click="openView">直链下载</el-button> 
        <el-button @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { versionAll } from "@/api/basic";
import QRCode from "qrcodejs2";
import { getPatch } from "@/api/common";

export default {
  name: "downloads",
  data() {
    return {
      dialogVisible: false,
      typeMap: {
        1: "Android",
        // 2: "iOS",
        // 3: "Windows",
        // 4: "MacOS",
      },
      typeArr: [
        { type: "1", name: "Android", url: require("@/assets/images/dow_AND.png"), dis: "为Android系统设计的全功能客户端" },
        // { type: "2", name: "iOS", url: require("@/assets/images/dow_IOS.png"), dis: "为iOS系统设计的全功能客户端" },
        // { type: "3", name: "Windows", url: require("@/assets/images/dow_WIN.png"), dis: "为Windows系统设计的全功能客户端" },
        // { type: "4", name: "MacOS", url: require("@/assets/images/dow_MACOS.png"), dis: "为MacOS系统设计的全功能客户端" },
      ],
      versionArr: [],
      Url: "",
      logoUrl: '',  //logo图片地址
    };
  },
  computed: {
    
  },
  mounted() {
    this.getLogoImg();
    versionAll().then((res) => {
      this.versionArr = res.result;
    });
  },
  methods: {
    // 获取logo图片
    getLogoImg(){
      const params = {
        tag: 'logo',
      };
      getPatch(params).then(res => {
          this.logoUrl = res.result.content;
      });
    },
    openView(){
          window.open(this.Url, "_blank");
          this.dialogVisible = true;
    },
    openDialog() {
      this.$refs["qrCodeUrl"].innerHTML = ""; //清除二维码方法一
      new QRCode(this.$refs["qrCodeUrl"], {
        text: this.Url,
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    openDow(item) {
      switch (item.type) {
        case 1:
          this.Url = item.jump_url;
          this.dialogVisible = true;
          break;
        case 2:
          this.Url = item.jump_url;
          this.dialogVisible = true;

          break;
        case 3:
          window.open(item.jump_url + item.yaml_content.path, "_blank");
          break;
        case 4:
          break;
        default:
          window.open(item.jump_url + item.yaml_content.path, "_blank");
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.downloads {
}
#app {
  min-width: 0px;
}
.head {
  width: 100%;
  height: 70px;
  position: relative;
  background-color: #d1d0d0;
  padding-top: 10px;
  padding-bottom: 10px;
  //   @include linearGradient("linear-gradient-start", "linear-gradient-end");
  img {
    margin-left: 3%;
    height: 100%;
  }
  .head_Return {
    position: absolute;
    margin-left: 3%;
    margin-top: auto;
    margin-bottom: auto;
    top: 25%;
    right: 1%;
    font-size: 20px;
    color: #fff;
  }
}
.cont {
  margin: 0 auto;
  margin-top: 5%;
  width: 100%;
}
.box-card {
  width: 100%;
}
.text {
  height: 90px;
}
.dow_icon {
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  background: url("~@/assets/images/dow.png") no-repeat;
  background-size: 100% 100%;
}
.dialog {
  #qrCode {
    img {
      display: block;
      margin: 0 auto;
    }
  }
  .describe {
    margin-top: 15px;
  }
  text-align: center;
}
</style>
